module.exports = __webpack_public_path__ + "static/media/orange-filled-star.42326dcc.svg";